import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { MobileInventorIntegrationStatus } from '../model/types';

export const getMobileInventorIntegrationAPI = async () => {
  const response = await baseAPI.get<MobileInventorIntegrationStatus>(
    'mobile-inventor-push/integration',
  );
  return response.data;
};

export const getMobileInventorIntegrationOptions = () =>
  queryOptions({
    queryKey: QUERY_KEYS.MOBILE_INVENTOR_PUSH_INTEGRATION(),
    queryFn: getMobileInventorIntegrationAPI,
  });

export const useGetMobileInventorIntegration = () =>
  useQuery(getMobileInventorIntegrationOptions());
